import { Constants, Utils } from "@zanichelli/myz-react-utils";

import { call, put, takeEvery } from "redux-saga/effects";

import { API } from "../../../beans";
import { get } from "../../../utils/requestV3MyzToken";

import {
  IMyzTokenUserRequest,
  MyzTokenUserAction,
  MyzTokenUserActionEnum,
  myzTokenUserFail,
  myzTokenUserSuccess,
} from "./actions";

export function* myzTokenUserRequestSaga(action: IMyzTokenUserRequest) {
  const requestURL = "/dashboard/user";
  const requestOpt = {
    headers: {
      [Constants.ENV.MYZ_TOKEN_KEY]: Utils.getMyzTokenCookie(),
    },
  };

  try {
    const { data } = yield call(get, requestURL, requestOpt);
    yield put(myzTokenUserSuccess(data));
  } catch (err) {
    yield put(myzTokenUserFail(err));
  }
}

export function* sagas() {
  yield takeEvery(MyzTokenUserActionEnum.REQUEST, myzTokenUserRequestSaga);
}

export interface IMyzTokenUserState {
  loading: boolean;
  loaded: null | boolean;
  data: null | API.MyzTokenUser;
  error: null | Error;
}

const initialState: IMyzTokenUserState = {
  loading: false,
  loaded: null,
  data: null,
  error: null,
};

const MyzTokenUser = (
  state: IMyzTokenUserState = initialState,
  action: MyzTokenUserAction,
): IMyzTokenUserState => {
  switch (action.type) {
    case MyzTokenUserActionEnum.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MyzTokenUserActionEnum.SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.data ? { ...action.data } : null,
      };
    case MyzTokenUserActionEnum.FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.err,
      };
    default:
      return state;
  }
};
export default MyzTokenUser;
